<template>
  <div>
    <v-card :loading="this.loading" rounded="xl" elevation="5" class="mx-5 px-5 py-5 my-5">
      <v-card-title>
        {{ $t('my_profile.title') }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field outlined
            v-model="firstName"
            :counter="128"
            :rules="fieldRequiredRules"
            append-icon="mdi-account-box-outline"
            v-bind:label="$t('my_profile.first_name')">
          </v-text-field>
          <v-text-field outlined
            v-model="lastName"
            :counter="128"
            :rules="fieldRequiredRules"
            append-icon="mdi-account-box-outline"
            v-bind:label="$t('my_profile.last_name')">
          </v-text-field>
          <v-text-field outlined
            v-model="email"
            :counter="254"
            :rules="emailRules"
            append-icon="mdi-email-outline"
            v-bind:label="$t('my_profile.email')">
          </v-text-field>
          <v-text-field outlined
            v-model="phone"
            :counter="255"
            append-icon="mdi-phone-outline"
            v-bind:label="$t('my_profile.phone')">
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="mx-5 d-flex justify-end">
        <v-btn color="primary" @click="saveProfileSettings">
          {{ $t('common_actions.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar color="error"
      v-model="errorDialogShow">
      {{ this.errorDialogText }}
    </v-snackbar>
    <v-snackbar color="success"
      v-model="successDialogShow">
      {{ this.successDialogText }}
    </v-snackbar>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'

export default {
  name: 'MyProfile',
  data: () => ({
    loading: false,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    fieldRequiredRules: [
      v => !!v || i18n.t('common_field_error.field_required')
    ],
    emailRules: [
      v => v === '' || /.+@.+\..+/.test(v) || i18n.t('my_profile.email_must_be_valid')
    ],
    errorDialogText: '',
    errorDialogShow: false,
    successDialogText: '',
    successDialogShow: false
  }),
  mounted () {
    this.firstName = this.comFirstName
    this.lastName = this.comLastName
    this.email = this.comEmail
    this.phone = this.comPhone

    this.loading = true
    this.$store.dispatch('basicUserInfo/refreshBasicUserInfo').then(_ => {
      this.firstName = this.$store.state.basicUserInfo.firstName
      this.lastName = this.$store.state.basicUserInfo.lastName
      this.email = this.$store.state.basicUserInfo.email
      this.phone = this.$store.state.basicUserInfo.phone

      this.loading = false
    }, _ => {
      this.loading = false

      this.errorDialogText = i18n.t('my_profile.failed_to_load_user_data')
      this.errorDialogShow = true
    })
  },
  computed: {
    comFirstName () {
      return this.$store.state.basicUserInfo.firstName
    },
    comLastName () {
      return this.$store.state.basicUserInfo.lastName
    },
    comEmail () {
      return this.$store.state.basicUserInfo.email
    },
    comPhone () {
      return this.$store.state.basicUserInfo.phone
    }
  },
  methods: {
    saveProfileSettings () {
      if (this.loading || !this.$refs.form.validate()) {
        return
      }
      this.$store.dispatch('basicUserInfo/editBasicUserInfo',
        {
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          email: this.email
        })
        .then(_ => {
          this.successDialogText = i18n.t('my_profile.save_success')
          this.successDialogShow = true
          this.loading = false
        }, _ => {
          this.errorDialogText = i18n.t('my_profile.failed_to_edit_user_data')
          this.errorDialogShow = true
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/MyProfile.vue